var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"eagle-form-item":"file"}},[_c('file-uploader',{attrs:{"type":_vm.fileType,"maxQuantity":_vm.maxQuantity,"disabled":_vm.disabled},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }